import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IApiResult } from '../shared/models/api-result';
import { ApiUrlProvider } from './api-url.provider';
import { Position} from '../shared/models/position';
import { User } from '../shared/models/user';
import { AccountViewModel, AddAccountViewModel, ResetPasswordViewModel, UpdateAccountViewModel, UpdatePasswordViewModel } from '../shared/models/update-account-view-model';

@Injectable({
  providedIn: 'root'
})
export class AccountService {
  constructor(private http: HttpClient, private apiUrlProvider: ApiUrlProvider) { }
  
  getAll(): Observable<IApiResult<AccountViewModel[]>>{
    return this.http.get<IApiResult<AccountViewModel[]>>(`${this.apiUrlProvider.url}/account`);
  }

  add(account: AddAccountViewModel): Observable<IApiResult<AddAccountViewModel>>{
    return this.http.post<IApiResult<AddAccountViewModel>>(`${this.apiUrlProvider.url}/account`, account);
  }

  update(user: UpdateAccountViewModel): Observable<IApiResult<UpdateAccountViewModel>>{
    return this.http.post<IApiResult<UpdateAccountViewModel>>(`${this.apiUrlProvider.url}/account/${user.userName}`, user);
  }

  updatePassword(user: UpdatePasswordViewModel): Observable<IApiResult<UpdatePasswordViewModel>>{
    return this.http.post<IApiResult<UpdatePasswordViewModel>>(`${this.apiUrlProvider.url}/account/${user.userName}/credential`, user);
  }

  delete(username: string): Observable<IApiResult<string>>{
    return this.http.post<IApiResult<string>>(`${this.apiUrlProvider.url}/account/${username}/delete`, null);
  }

  resetPassword(user: ResetPasswordViewModel): Observable<IApiResult<boolean>>{
    return this.http.post<IApiResult<boolean>>(`${this.apiUrlProvider.url}/account/${user.userName}/reset`, user);
  }
}
